import { render, staticRenderFns } from "./ContratoTarifario.vue?vue&type=template&id=2f4a470c"
import script from "./ContratoTarifario.vue?vue&type=script&lang=js"
export * from "./ContratoTarifario.vue?vue&type=script&lang=js"
import style0 from "./ContratoTarifario.vue?vue&type=style&index=0&id=2f4a470c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports